import React from 'react'
import { useTranslation } from 'react-i18next';
import { ReactComponent as ContactIdentification } from "../../../assets/contactIdentificationIcon.svg";
import { ReactComponent as TextBoxIcon } from "../../../assets/TextBoxIcon.svg";
import { ReactComponent as NumberIcon } from "../../../assets/NumberIcon.svg";
import { ReactComponent as UnitOfMeasurementIcon } from "../../../assets/UnitOfMeasurementIcon.svg";
import { ReactComponent as AmountIcon } from "../../../assets/AmountIcon.svg";
import { ReactComponent as DiscountIcon } from "../../../assets/DiscountIcon.svg";
import { ReactComponent as PercentageIcon } from "../../../assets/PercentageIcon.svg";
import { ReactComponent as DateIcon } from "../../../assets/DateIcon.svg";
import { ReactComponent as DateRangesIcon } from "../../../assets/DateRangesIcon.svg";
import { ReactComponent as LocationIcon } from "../../../assets/LocationIcon.svg";
import { ReactComponent as FilesMediaIcon } from "../../../assets/FilesMediaIcon.svg";
import { ReactComponent as listIcon } from "../../../assets/ListIconNew.svg";
import { ReactComponent as CategoryIcon } from "../../../assets/CategoryIcon.svg";
import { ReactComponent as TagIcon } from "../../../assets/TagIconNew.svg";
import { ReactComponent as StatusIcon } from "../../../assets/StatusIcon.svg";
import { ReactComponent as ChecklistIcon } from "../../../assets/ChecklistIcon.svg";
import { ReactComponent as EmailIcon } from "../../../assets/EmailIconNew.svg";
import { ReactComponent as PhoneIcon } from "../../../assets/phoneIcon.svg";
import { ReactComponent as ContactIcon } from "../../../assets/ContactIcon.svg";
import { ReactComponent as AssetIcon } from "../../../assets/AssetIcon.svg";
import { ReactComponent as UrlIcon } from "../../../assets/UrlIcon.svg";
import { ReactComponent as ChronometerIcon } from "../../../assets/ChronometerIcon.svg";
import { ReactComponent as VoiceRecorderIcon } from "../../../assets/VoiceRecorderIcon.svg";
import { ReactComponent as LanguageIcon } from "../../../assets/LanguageIcon.svg";
import { ReactComponent as FormulaIcon } from "../../../assets/FormulaIcon.svg";
import { ReactComponent as AssessmentIcon } from "../../../assets/AssessmentIcon.svg";
import ItemNavigation from '../ItemNavigation/ItemNavigation';
const ParameterNavigation = ({setParameterType}) => {
  const [t] = useTranslation("Contacts");

    
    const agentItems = [
        { id: "textBox", label: t('textBox'),Icon:TextBoxIcon },
        { id: "number", label: t('number'),Icon:NumberIcon },
        { id: "unitOfMeasurement", label: t('unitOfMeasurement'),Icon:UnitOfMeasurementIcon },
        { id: "amount", label: t('amount'),Icon:AmountIcon },
        { id: "discount", label: t('discount'),Icon:DiscountIcon },
        { id: "percentage", label: t('percentage'),Icon:PercentageIcon },
        { id: "date", label: t('date'),Icon:DateIcon },
        { id: "dateRanges", label: t('dateRanges'),Icon:DateRangesIcon },
        { id: "location", label: t('location'),Icon:LocationIcon },
        { id: "filesMedia", label: t('filesMedia'),Icon:FilesMediaIcon },
        { id: "list", label: t('list'),Icon:listIcon },
        { id: "category", label: t('category'),Icon:CategoryIcon },
        { id: "colorList", label: t('colorList'),Icon:ContactIdentification },
        { id: "tag", label: t('tag'),Icon:TagIcon },
        { id: "status", label: t('status'),Icon:StatusIcon },
        { id: "checklist", label: t('checklist'),Icon:ChecklistIcon },
        { id: "email", label: t('email'),Icon:EmailIcon },
        { id: "phone", label: t('phone'),Icon:PhoneIcon },
        { id: "contact", label: t('contact'),Icon:ContactIcon },
        { id: "asset", label: t('asset'),Icon:AssetIcon },
        { id: "url", label: t('Url'),Icon:UrlIcon },
        { id: "chronometer", label: t('chronometer'),Icon:ChronometerIcon },
        { id: "voiceRecorder", label: t('voiceRecorder'),Icon:VoiceRecorderIcon },
        { id: "language", label: t('language'),Icon:LanguageIcon },
        { id: "formula", label: t('formula'),Icon:FormulaIcon },
        { id: "assessment", label: t('assessment'),Icon:AssessmentIcon },
      ];
  return (
 <ItemNavigation items={agentItems} setTypeState={setParameterType}/>

  )
}

export default ParameterNavigation